import { render, staticRenderFns } from "./CartConfirmation.vue?vue&type=template&id=3b8155f7&"
import script from "./CartConfirmation.vue?vue&type=script&lang=js&"
export * from "./CartConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports